import { ApolloError, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'

import { PoolAndPairQuery } from './__generated__/types-and-hooks'
import { apolloCompetitionClient } from './apollo'

const query = gql`
  query PoolAndPair {
    pools(first: 100) {
      id
      txCount
      feeTier
      token0 {
        id
        symbol
      }
      token1 {
        id
        symbol
      }
    }

    pairs(first: 100) {
      id
      txCount
      token0 {
        id
        symbol
      }
      token1 {
        id
        symbol
      }
    }

    tokens(first: 100) {
      id
      symbol
      name
      multiplier
      multiplierStart
      multiplierEnd
    }
  }
`

export default function usePoolAndPairQuery(): {
  error?: ApolloError
  isLoading: boolean
  data: PoolAndPairQuery
} {
  const {
    data,
    loading: isLoading,
    error,
  } = useQuery(query, {
    client: apolloCompetitionClient,
  })

  return useMemo(
    () => ({
      error,
      isLoading,
      data,
    }),
    [data, error, isLoading]
  )
}
